export default {
  toasts: {
    load_error: 'Gebührensätze konnten nicht geladen werden',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen gespeichert',
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  rates: {
    title: 'Verarbeitungsmarge',
    description:
      'Prozentsatz in %, dazu optional ein fester und ein Mindestbetrag pro Zahlung. „Alle Zahlungsarten“ greift, wenn kein artspezifischer Satz existiert.',
    default: {
      inherits:
        'Es ist kein Adyen-Satz hinterlegt, daher zahlen die Restaurants dieses Partners auf dem Adyen-Konto von FoodAmigos die unten stehenden FoodAmigos-Standardsätze. Ein hier hinterlegter Satz ersetzt diese; ein für ein einzelnes Restaurant hinterlegter Satz hat weiterhin Vorrang.',
      overridden:
        'Der eigene Adyen-Satz dieses Partners ersetzt für seine Restaurants auf dem Adyen-Konto von FoodAmigos die unten stehenden Standardsätze. Entfernen Sie ihn, gelten wieder die Standardsätze.',
      own_adyen:
        'Dieser Partner wickelt Zahlungen über sein eigenes Adyen-Konto ab. Seine Restaurants zahlen keine Verarbeitungsgebühr, solange weder hier noch für ein einzelnes Restaurant ein Satz hinterlegt ist.',
      master:
        'Dies sind die FoodAmigos-Standardsätze. Sie gelten für jeden Partner auf dem Adyen-Konto von FoodAmigos ohne eigenen Adyen-Satz.',
      rows_title: 'FoodAmigos-Standardsätze',
    },
  },
};
